import React, { useEffect } from 'react';
import { FiArrowLeft, FiSearch } from 'react-icons/fi';
import Footer from '../components/Footer';
import Header from '../components/Header';

export default function NotFoundPage() {
  useEffect(() => {
    document.title = 'Page Not Found | Learnaicare';

    let robots = document.head.querySelector<HTMLMetaElement>('meta[name="robots"]');
    const createdRobotsTag = !robots;
    const previousRobotsContent = robots?.getAttribute('content');
    if (!robots) {
      robots = document.createElement('meta');
      robots.name = 'robots';
      document.head.appendChild(robots);
    }
    robots.content = 'noindex, nofollow';

    return () => {
      if (createdRobotsTag) {
        robots?.remove();
      } else if (robots) {
        if (previousRobotsContent == null) {
          robots.removeAttribute('content');
        } else {
          robots.content = previousRobotsContent;
        }
      }
    };
  }, []);

  return (
    <div className="page-shell min-h-screen flex flex-col">
      <Header />
      <main className="flex flex-1 items-center justify-center px-4 py-16 sm:px-6">
        <section className="w-full max-w-xl rounded-2xl border border-[#d5e3ed] bg-white/90 p-8 text-center shadow-[0_16px_45px_-24px_rgba(7,26,49,0.25)] sm:p-12">
          <FiSearch className="mx-auto h-10 w-10 text-[var(--brand-accent)]" aria-hidden="true" />
          <p className="mt-5 text-sm font-bold tracking-[0.22em] text-[var(--brand-accent)]">ERROR 404</p>
          <h1 className="mt-3 text-3xl font-bold text-[var(--brand-ink)] sm:text-4xl">Page not found</h1>
          <p className="mt-4 text-sm leading-7 text-[var(--text-muted)] sm:text-base">
            The page you requested does not exist or may have moved.
          </p>
          <a
            href="/"
            className="mt-8 inline-flex items-center gap-2 rounded-lg bg-[var(--brand-accent)] px-5 py-3 text-sm font-semibold text-white transition-colors hover:bg-[var(--brand-deep)]"
          >
            <FiArrowLeft aria-hidden="true" />
            Return to home
          </a>
        </section>
      </main>
      <Footer />
    </div>
  );
}
